// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overclaim-bulk-action-control-wrapper .upload-documentation-form {
  flex-direction: row;
  margin-top: 2rem;
  gap: 1.8rem;
}
.overclaim-bulk-action-control-wrapper .upload-documentation-form .upload-and-submit {
  flex-basis: 66%;
}
.overclaim-bulk-action-control-wrapper .upload-documentation-form .files-preview {
  flex-basis: 40%;
}
.overclaim-bulk-action-control-wrapper .upload-documentation-form .browse-files-label {
  width: 38%;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/OverclaimBulkAction/DocumentBulkAction/index.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;AAAJ;AAEI;EACE,eAAA;AAAN;AAGI;EACE,eAAA;AADN;AAII;EACE,UAAA;AAFN","sourcesContent":[".overclaim-bulk-action-control-wrapper {\n  .upload-documentation-form {\n    flex-direction: row;\n    margin-top: 2rem;\n    gap: 1.8rem;\n\n    .upload-and-submit {\n      flex-basis: 66%;\n    }\n\n    .files-preview {\n      flex-basis: 40%;\n    }\n\n    .browse-files-label {\n      width: 38%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
